import state from "./state"

/**
 * @module vuex/getters
 */
export default {
    currSessionMsgs: state => {
        return state.currSessionMsgs
    },
    getsessionList: state => {
        return state.sessionlist;
    },
    //获取我的好友列表
    getMyfriends: state => {
        return state.friendList
    },
    // 获取当前聊天对象的信息
    getCurrentChatInfo: state => {
        return state.currChatUserInfo
    },
    // 获取当前登录的用户信息
    getCurrentLoginInfo: state => {
        return state.myInfo;
    },
    getCurrentChatGroupInfo: state => {
        return state.currChatGroupInfo;
    },
    //系统通知对象数组
    getSysMsgList: state => {
        return state.sysMsgs;
    },
    //群组列表
    getGroupList: state => {
        return state.groupList;
    },
    getCurrSessionId: state => {
        return state.currSessionId
    },
    // 获取选中人员
    getselectpersonnelList: state => {
        return state.selectpersonnelList;
    },
    // 获取当前聊天对象id
    getcurrSessionTo: state => {
        return state.currSessionTo;
    },
    // 获取homeIndex
    gethomeActiveIndexTag: state => {
        return state.homeActiveIndexTag;
    }
}



// WEBPACK FOOTER //
// ./src/store/getters.js